module.exports = __webpack_public_path__ + "static/media/logo.6ff0f67e.png";